import {observable} from "mobx";
import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";

export class MyAccountUiStore extends ApiCallObservable<any> {

  @observable public headerCloseIcon: boolean = true;
  @observable public cardsController: boolean[] = [];
}



// WEBPACK FOOTER //
// ./src/scenes/MyAccount/state/mobx/MyAccountUiStore.ts